export default "__VITE_ASSET__SMKwiFs1__"